export default __webpack_public_path__ + "static/media/campanha_arrecadacao.947fee02.svg";